import { number, object } from 'yup'

export const formFieldGroups = {
  cash: {
    cash: 'Cash & Equivalents',
    savings: 'Savings',
    chequing: 'Chequing',
  },
  otherAssets: {
    auto: 'Auto Property',
    residence: 'Primary Residence',
    cottage: 'Cottage',
    realEstate: 'Other Real Estate',
    businessAssets: 'Business Assets',
  },
  investments: {
    rrsp: 'RRSPs',
    noRegistered: 'Non-Registered Accounts',
    pension: 'Defined Contribution Pension Plan',
    tfsa: 'TFSAs',
    otherInvestments: 'Other Investments',
  },
  insurance: {
    term: 'Term Insurance',
    permanent: 'Permanent Insurance',
  },
  liabilities: {
    mortgage: 'Mortgage',
    creditLine: 'Line of Credit',
    autoLoan: 'Automobile Loan',
    creditCards: 'Credit Cards',
    other: 'Other Liabilities',
  },
}

export const initialValues = {}
const validationFields = {}

// https://github.com/jquense/yup/issues/66#issuecomment-318486137
Object.entries(formFieldGroups).forEach(([groupId, group]) => {
  Object.keys(group).forEach(fieldId => {
    const key = `${groupId}-${fieldId}`
    initialValues[key] = ''
    validationFields[key] = number()
      .transform((cv, ov) => (ov === '' ? undefined : cv))
      .typeError('must be a number')
  })
})

export const formSchema = object(validationFields)
